import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import { Select, Button, FormGroup, Label, InputGroup, InputGroupText, SimpleAlert } from 'twyne-new.ui';

import Groups from './Groups';
import { conditionOptions } from './utils';

const propTypes = {
  data: PropTypes.object,
  options: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  nested: PropTypes.bool,
};

const defaultProps = {
  disabled: false,
  nested: true,
}

export default function Rules({ data, options, conditions, onChange, disabled, children }) {
  const [rules, setRules] = useState(DEFAULT)

  const handleChange = rules => {
    const update = { ...rules }
    setRules(update)
    onChange(update)
  }

  useEffect(() => {
    data && handleChange(data)
  }, [])

  const handleChangeCondition = option => {
    rules.condition = option ? option.value : null
    handleChange(rules)
  }

  const handleAddGroup = () => {
    const group = { condition: 'and', rules: [{}] }
    rules.groups.push(group)
    handleChange(rules)
  }

  return <div>
    <FormGroup>
      <Label>
        When match with
      </Label>
      <InputGroup>
        <Select
          required
          value={rules.condition}
          clearable={false}
          disabled={disabled}
          options={conditions?.groups || conditionOptions}
          onChange={handleChangeCondition}
        />
        <InputGroupText addonType="append">
          Groups
        </InputGroupText>
      </InputGroup>
      {children ? children : <TestAlert rules={rules} disabled={disabled} />}
    </FormGroup>
    <Groups
      data={rules}
      options={options}
      conditions={conditions}
      onChange={handleChange}
      disabled={disabled}
    />
    <Button color="success" onClick={handleAddGroup} disabled={disabled}>
      Add Group
    </Button>
  </div>
}

const DEFAULT = { condition: 'and', groups: [] }

Rules.propTypes = propTypes
Rules.defaultProps = defaultProps

function TestAlert({ disabled, rules }) {
  const { condition, groups } = rules

  if (!disabled && condition && !groups?.length) {
    return <SimpleAlert className="mt-2!" variant="warning">
      {condition === 'none' ? <>
        No rules group, <strong>the test will pass</strong></> : <>
        No rules group, <strong>the test will not pass</strong></>}
    </SimpleAlert>
  }

  return null
}
